import React from 'react'
import api from '../../../../context/apiContext'
import { showResponseError, showResponseSuccess } from '../../../../helper'
import FormDataRepository, { ISaveFormData } from './FormData'
import { KeyedMutator } from 'swr'
import { IRepositories } from '..'

interface IAddRepository {
  onCloseModal: () => void
  mutate: KeyedMutator<IRepositories>
}

const AddRepository = (props: IAddRepository) => {
  const {
    onCloseModal,
    mutate,
  } = props

  const handleSave = async (data: ISaveFormData) => {

    await api({
      method: 'POST',
      url: 'repositories',
      data
    })
      .then(({ data }) => {
        showResponseSuccess(data?.message)
        mutate()
        onCloseModal()
      })
      .catch(error => showResponseError(error))
  }

  return (
    <FormDataRepository
      onCloseModal={onCloseModal}
      onSaveForm={handleSave}
    />
  )
}

export default AddRepository